import Entity from "./entity";
import Mass from "./mass";
import Health from "./health";
import Speed from "./speed";
import Quips from "./quips";
import Storylet from "./storylet";
import Equipment from "./equipment";

class Character extends Entity {
  constructor(id, glyph, speed, quips, storyAsset) {
    super(null, null, glyph, id, {
      mass: new Mass(Mass.Medium),
      speed: new Speed(speed),
      health: new Health(1),
      quips: new Quips(quips),
      story: new Storylet(storyAsset),
      equipment: Equipment.blankSheet()
    });
  }

  get description() {
    return this.quips.lookDescription();
  }

  canTakeTurn() {
    return false;
  }

  takeTurn(stage) {
    return true;
  }

  bumpFrom(entity, stage) {
    if (entity.isPlayer()) {
      entity.social.meeting(this.name);

      if (this.story.canStart) {
        this.story.startFlow(stage);
      } else if (this.story.canContinue()) {
        this.story.continueFlow(stage);
      } else {
        document.dispatchEvent(new CustomEvent("ui.transition", {
          detail: {
            command: "ShowQuip",
            description: this.quips.bumpDescription()
          }
        }));
      }
    }
  }
}

export default Character;